import clsx from "clsx";

interface KeyValueRowProps {
  label: string;
  value: string | null | undefined;
  className?: string;
}

export const KeyValueRow = ({ label, value, className }: KeyValueRowProps) => (
  <div
    className={clsx(
      "grid grid-cols-3 gap-2 border-b border-slate-100 py-2 last:border-b-0",
      className,
    )}
  >
    <span className="text-xs font-medium uppercase tracking-wide text-ink-secondary">
      {label}
    </span>
    <span className="col-span-2 text-sm text-ink-primary">
      {value && value.length > 0 ? value : <em className="text-ink-secondary">—</em>}
    </span>
  </div>
);